'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Cut = function Cut(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 12 12' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M2.467.897a1.545 1.545 0 1 0 0 3.09 1.545 1.545 0 0 0 0-3.09zm0-.91a2.455 2.455 0 1 1 0 4.91 2.455 2.455 0 0 1 0-4.91zM2.467 7.975a1.545 1.545 0 1 0 0 3.09 1.545 1.545 0 0 0 0-3.09zm0-.91a2.455 2.455 0 1 1 0 4.91 2.455 2.455 0 0 1 0-4.91z'
      }),
      _react2.default.createElement('path', { d: 'M11.239 1.048l-7.37 6.9a.455.455 0 1 0 .622.664l7.37-6.9a.455.455 0 1 0-.622-.664zM7.136 7.39l4.08 3.89a.455.455 0 0 0 .628-.66l-4.08-3.888a.455.455 0 0 0-.628.659z'
      }),
      _react2.default.createElement('path', { d: 'M3.572 4.006l2.59 2.45a.456.456 0 0 0 .626-.66l-2.59-2.45c-.182-.173-.213.004-.386.186-.173.183-.422.301-.24.474z' })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Cut;